// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vNom8","toggle":"styles_toggle__2g0A3","preview":"styles_preview__2kxAk"};